import { useEffect, useRef } from 'react';

/** Invalidate deferred login and payment work when this invoice stops being actionable. */
export const useFactorActionGuard = (disabled: boolean, identity: string) => {
  const state = useRef({ disabled, identity, generation: 0, mounted: true });
  if (state.current.disabled !== disabled || state.current.identity !== identity) {
    state.current = { ...state.current, disabled, identity, generation: state.current.generation + 1 };
  }
  useEffect(() => {
    state.current.mounted = true;
    return () => { state.current.mounted = false; state.current.generation++; };
  }, []);
  return () => {
    const generation = state.current.generation;
    return () => state.current.mounted && !state.current.disabled && state.current.generation === generation;
  };
};
